export default "__VITE_ASSET__mDHnZCKz__"